import userInfo from 'utils/userInfo';

const toModel = (tips, origEatery) => {
  if (!origEatery) {
    return tips.map(({ tip }) => tip);
  }

  const model = { post: [], put: [], del: [] };

  const tipsObj = tips.reduce((acc, { id, tip }) => {
    if (id.toString().startsWith('__isNew-')) {
      model.post.push({
        resourceId: origEatery.id,
        resourceType: 'EATERY',
        tip,
        owner: {
          id: userInfo.getUserID(),
        },
      });
    } else {
      acc[id] = tip;
    }
    return acc;
  }, {});

  return origEatery.curatorTips.reduce((acc, { id, tip }) => {
    if (!tipsObj[id]) {
      acc.del.push(id);
    } else if (tip !== tipsObj[id]) {
      acc.put.push({ id, tip: tipsObj[id] });
    }

    return acc;
  }, model);
};

export default {
  toModel,
};
